const locale = {
    "ru": {
        months: [
            "Январь", "Февраль", "Март", "Апрель", "Май", "Июнь",
            "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"
        ],
        common: {

            loading: "Загрузка...",
            notSpecified: "Не указан",
            noData: "Нет данных",
            collapse: "Свернуть",
            expand: "Развернуть",
            close: "Закрыть",
            save: "Сохранить",
            cancel: "Отмена",
            delete: "Удалить",
            edit: "Редактировать",
            add: "Добавить",
            search: "Поиск",
            filter: "Фильтр",
            apply: "Применить",
            reset: "Сбросить",
            back: "Назад",
            next: "Вперед",
            previous: "Предыдущий",
            page: "Страница",
            of: "из",
            total: "Всего",
            yes: "Да",
            no: "Нет",
            all: "Все",
            none: "Нет",
            error: "Ошибка",
            success: "Успешно",
            warning: "Предупреждение",
            info: "Информация"

        },
        menuField: {
            title: "Меню",
            toOpen: "Открыть меню",
            fields: {
                selectedPoint: "Выбранная точка"
            }
        },
        product: {
            title: "Выбор продукта",
            previous: "Предыдущий продукт",
            next: "Следующий продукт",
            loading: "Загрузка продуктов...",
            noProducts: "Нет доступных продуктов",
            demoProduct: "Демо-продукт"
        },
        city: {
            title: "Выбор города",
            select: "Выберите город",
            noCities: "Нет доступных городов",
            currentCity: "Текущий город"
        },
        layers: {
            title: "Слои",
            noLayers: "Нет доступных слоев",
            selectLayer: "Выберите слой",
            features: "Подслои",
            noFeatures: "Нет подслоев"
        },
        time: {
            year: {
                title: "Выбор года",
                noData: "Нет данных по годам",
                select: "Выберите год"
            },
            month: {
                title: "Выбор месяца",
                noData: "Нет данных по месяцам",
                select: "Выберите месяц",
                all: "Весь год"
            }
        },
        selectedPoint: {
            title: "Выбранная точка",
            noSelection: "Кликните на область на карте",
            loading: "Загрузка данных точки...",
            data: "Данные точки",
            value: "Значение",
            feature: "Характеристика",
            noData: "Нет данных для этой точки",
            coordinates: "Координаты",
            h3Index: "Индекс H3",
            aggregated: "Суммарно по всем областям",
            area: "Область",
            hexCount: ["гекс", "гекса", "гексов"]
        },
        map: {
            title: "Карта",
            zoomIn: "Приблизить",
            zoomOut: "Отдалить",
            resetView: "Сбросить вид",
            fullscreen: "Полный экран",
            coordinates: "Координаты",
            loading: "Загрузка карты...",
            error: "Ошибка загрузки карты",
            attribution: "© OpenStreetMap"
        },
        colorsPanel: {
            title: "Цветовая шкала",
            min: "Мин",
            max: "Макс",
            average: "Среднее",
            noData: "Нет данных",
            gradient: "Градиент",
            legend: "Легенда",
            competitors: {
                title: "Конкуренты",
                low: "Низкая конкуренция",
                medium: "Средняя конкуренция",
                high: "Высокая конкуренция"
            }
        },
        errors: {
            network: "Ошибка сети. Проверьте подключение",
            server: "Ошибка сервера. Попробуйте позже",
            unauthorized: "Не авторизован. Войдите в систему",
            forbidden: "Доступ запрещен",
            notFound: "Ресурс не найден",
            timeout: "Время ожидания истекло",
            unknown: "Неизвестная ошибка",
            validation: "Ошибка валидации",
            dataLoad: "Ошибка загрузки данных",
            dataSave: "Ошибка сохранения данных",
            dataDelete: "Ошибка удаления данных"
        },
        actions: {
            retry: "Повторить",
            refresh: "Обновить",
            logout: "Выйти",
            login: "Войти",
            profile: "Профиль",
            settings: "Настройки",
            help: "Помощь",
            feedback: "Обратная связь",
            about: "О программе"
        }
    },
    "en": {
        months: [
            "January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
        ],
        common: {
            loading: "Loading...",
            notSpecified: "Not specified",
            noData: "No data",
            collapse: "Collapse",
            expand: "Expand",
            close: "Close",
            save: "Save",
            cancel: "Cancel",
            delete: "Delete",
            edit: "Edit",
            add: "Add",
            search: "Search",
            filter: "Filter",
            apply: "Apply",
            reset: "Reset",
            back: "Back",
            next: "Next",
            previous: "Previous",
            page: "Page",
            of: "of",
            total: "Total",
            yes: "Yes",
            no: "No",
            all: "All",
            none: "None",
            error: "Error",
            success: "Success",
            warning: "Warning",
            info: "Info"
        },
        menuField: {
            title: "Menu",
            toOpen: "Open menu",
            fields: {
                selectedPoint: "Selected point"
            }
        },
        product: {
            title: "Product Selection",
            previous: "Previous product",
            next: "Next product",
            loading: "Loading products...",
            noProducts: "No products available",
            demoProduct: "Demo product"
        },
        city: {
            title: "City Selection",
            select: "Select city",
            noCities: "No cities available",
            currentCity: "Current city"
        },
        layers: {
            title: "Layers",
            noLayers: "No layers available",
            selectLayer: "Select layer",
            features: "Sub-layers",
            noFeatures: "No sub-layers"
        },
        time: {
            year: {
                title: "Year Selection",
                noData: "No year data",
                select: "Select year"
            },
            month: {
                title: "Month Selection",
                noData: "No month data",
                select: "Select month",
                all: "Whole year"
            }
        },
        selectedPoint: {
            title: "Selected Point",
            noSelection: "Click on an area on the map",
            loading: "Loading point data...",
            data: "Point data",
            value: "Value",
            feature: "Feature",
            noData: "No data for this point",
            coordinates: "Coordinates",
            h3Index: "H3 Index",
            aggregated: "Aggregated across all areas",
            area: "Area",
            hexCount: ["hex", "hexes", "hexes"]
        },
        map: {
            title: "Map",
            zoomIn: "Zoom in",
            zoomOut: "Zoom out",
            resetView: "Reset view",
            fullscreen: "Full screen",
            coordinates: "Coordinates",
            loading: "Loading map...",
            error: "Map loading error",
            attribution: "© OpenStreetMap"
        },
        colorsPanel: {
            title: "Color Scale",
            min: "Min",
            max: "Max",
            average: "Average",
            noData: "No data",
            gradient: "Gradient",
            legend: "Legend",
            competitors: {
                title: "Competitors",
                low: "Low competition",
                medium: "Medium competition",
                high: "High competition"
            }
        },
        errors: {
            network: "Network error. Check your connection",
            server: "Server error. Try again later",
            unauthorized: "Unauthorized. Please log in",
            forbidden: "Access denied",
            notFound: "Resource not found",
            timeout: "Request timeout",
            unknown: "Unknown error",
            validation: "Validation error",
            dataLoad: "Data loading error",
            dataSave: "Data saving error",
            dataDelete: "Data deletion error"
        },
        actions: {
            retry: "Retry",
            refresh: "Refresh",
            logout: "Log out",
            login: "Log in",
            profile: "Profile",
            settings: "Settings",
            help: "Help",
            feedback: "Feedback",
            about: "About"
        }
    }
};

export default locale;